import React, { useState, useEffect } from 'react';
import Button from '@sabre/spark-react-core/button';
import Checkbox from '@sabre/spark-react-core/checkbox';
import Icon from '@sabre/spark-react-core/icon';
import TextInput from '@sabre/spark-react-core/text-input';
import Tooltip from '@sabre/spark-react-core/tooltip';
import { func, object, array, bool, any, number } from 'prop-types';
import { Popover } from 'react-tiny-popover';

const TableHeader = ({
   handleEnablesHeadersControls,
   handleSorting,
   handleUniqueItemClick,
   uniqueFilters,
   handleShowSearchFilters,
   handleFilterChange,
   item,
   headerData,
   rowData,
   isScroll,
   isMultiFilter,
   isToolTipShow,
   handleSelectAllUpdate,
   handleClearEvent,
   handleFilterUniqueItems,
}) => {
   const [selectAll, setSelectAll] = useState(false);
   const [tableHeaderConfig, setTableHeaderConfig] = useState({
      isShowFilterControls: item.isShowFilterControls,
      isFilterOpen: item.isFilterOpen,
      uniqueFilters: item.uniqueFilters,
   });
   useEffect(() => {
      setTableHeaderConfig({
         ...tableHeaderConfig,
         uniqueFilters: item.uniqueFilters,
      });
   }, [item.uniqueFilters]);

   const handleSelectAllClick = (item) => {
      setSelectAll(!selectAll);
      const updatedResult = tableHeaderConfig.uniqueFilters.map((list) => {
         list.value = !selectAll;
         return list;
      });
      setTableHeaderConfig({
         ...tableHeaderConfig,
         uniqueFilters: updatedResult,
      });
   };
   const handleShowControls = (item) => {
      if (item.key === 'fav' || rowData.length === 0) return;
      setTableHeaderConfig({
         ...tableHeaderConfig,
         isShowFilterControls: true,
         isFilterOpen: false,
      });
   };
   const handleHideControls = () => {
      if (!tableHeaderConfig.isFilterOpen)
         setTableHeaderConfig({
            ...tableHeaderConfig,
            isShowFilterControls: false,
         });
   };
   const handleShowFilter = () => {
      if (rowData.length === 0) return;
      setTableHeaderConfig({ ...tableHeaderConfig, isFilterOpen: true });
   };
   const handleHideFilter = () => {
      setTableHeaderConfig({
         ...tableHeaderConfig,
         isFilterOpen: false,
         isShowFilterControls: false,
      });
   };
   const handleUniqueItem = (subItem) => {
      const updateResult = tableHeaderConfig.uniqueFilters.map((item) => {
         if (item.key === subItem.key) item.value = !item.value;
         return item;
      });
      setTableHeaderConfig({
         ...tableHeaderConfig,
         uniqueFilters: updateResult,
      });
   };
   const formatHeader = (headerValue) =>
      headerValue.replace(/([A-Z])/g, ' $1').trim();
   useEffect(() => {
      if (item.uniqueFilters) {
         const isSelectAll = item.uniqueFilters.every(
            (subList) => subList.value === true
         );
         isSelectAll ? setSelectAll(true) : setSelectAll(false);
      }
   }, [headerData]);
   return (
      <div
         className={`custom-cell spark-flex ${
            !isScroll && item.key.length < 4 ? 'spark-mar-l-.5' : ''
         }`}
         onMouseEnter={() => handleShowControls(item)}
         onMouseLeave={handleHideControls}
      >
         {isToolTipShow ? (
            <Tooltip
               anchorY='top'
               anchorX='center'
               toggleEl={
                  <div data-testid={`header-${item.key}-id`}>
                     {formatHeader(item.key)}
                  </div>
               }
            >
               {item.title}
            </Tooltip>
         ) : (
            <div data-testid={`header-${item.key}-id`}>
               {formatHeader(item.key)}
            </div>
         )}
         <span>
            {tableHeaderConfig.isShowFilterControls && (
               <div className='header-icon spark-flex'>
                  {item.isDefault || item.isDecending ? (
                     <Icon
                        name='arrow-triangle-up'
                        size='md'
                        style='fill'
                        onClick={() => handleSorting(item)}
                        label='Show Stored Criteria'
                     />
                  ) : (
                     item.isAscending && (
                        <Icon
                           name='arrow-triangle-down'
                           size='md'
                           style='fill'
                           onClick={() => handleSorting(item)}
                           label='Show Stored Criteria'
                        />
                     )
                  )}

                  <Popover
                     isOpen={tableHeaderConfig.isFilterOpen}
                     positions={['bottom']}
                     containerClassName={` ${
                        isMultiFilter ? 'pop-bg-multi' : 'pop-bg'
                     }`}
                     onClickOutside={handleHideFilter}
                     padding={3}
                     content={
                        <div
                           className='full-height'
                           onMouseEnter={handleShowFilter}
                        >
                           <TextInput
                              className='spark-pad-l-.5'
                              name={`Search ${item.key}`}
                              placeholder={`Search ${item.key}`}
                              value={item.filterValue}
                              onChange={(event, selectedValue) =>
                                 handleFilterChange(
                                    selectedValue,
                                    item,
                                    rowData
                                 )
                              }
                           />
                           {isMultiFilter && item.uniqueFilters.length > 0 && (
                              <div>
                                 {' '}
                                 <div className='full-height-button'>
                                    <div className='row'>
                                       <div>
                                          <Checkbox
                                             className='spark-bold spark-align-items-center'
                                             label='Select All'
                                             checked={selectAll}
                                             onChange={() =>
                                                handleSelectAllClick(item)
                                             }
                                          />
                                       </div>
                                    </div>
                                    <div
                                       className={` ${
                                          item.uniqueFilters.length > 4
                                             ? 'popup-checkbox-content'
                                             : 'popup-checkbox-min-content'
                                       } table-view-auto-x-scroll`}
                                    >
                                       {tableHeaderConfig.uniqueFilters.map(
                                          (subItem, index) => {
                                             return (
                                                <Checkbox
                                                   key={index}
                                                   className='spark-bold spark-align-items-center'
                                                   label={subItem.key}
                                                   checked={subItem.value}
                                                   onChange={() =>
                                                      handleUniqueItem(subItem)
                                                   }
                                                />
                                             );
                                          }
                                       )}
                                    </div>
                                 </div>
                                 <div className='row popup-up-controls'>
                                    <Button
                                       className='spark-btn-group-secondary select-button-cancel popup-up-controls-ok-button'
                                       size='xs'
                                       primary='true'
                                       disabled={item.uniqueFilters.every(
                                          (item) => !item.value
                                       )}
                                       onClick={() =>
                                          handleFilterUniqueItems(
                                             item,
                                             isScroll
                                          )
                                       }
                                    >
                                       Apply
                                    </Button>
                                    <Button
                                       className='spark-btn-group-primary'
                                       size='xs'
                                       secondary='true'
                                       onClick={() =>
                                          handleClearEvent(
                                             item,
                                             headerData,
                                             isScroll,
                                             true
                                          )
                                       }
                                    >
                                       Clear
                                    </Button>
                                 </div>
                              </div>
                           )}
                        </div>
                     }
                  >
                     <div>
                        {!item.isFilterApply && (
                           <Icon
                              name='menu-hamburger'
                              onClick={handleShowFilter}
                              size='md'
                              style='fill'
                              label='Show Stored Criteria'
                           />
                        )}
                     </div>
                  </Popover>
               </div>
            )}
         </span>
         {item.isFilterApply && (
            <div className='edit-icon spark-pad-l-.5'>
               <Icon
                  name='pencil'
                  onClick={handleShowFilter}
                  size='md'
                  style='fill'
                  label='Show Stored Criteria'
               />
            </div>
         )}
      </div>
   );
};
TableHeader.propTypes = {
   handleEnablesHeadersControls: func,
   handleSorting: func,
   handleShowSearchFilters: func,
   handleFilterChange: func,
   handleUniqueItemClick: func,
   handleSelectAllUpdate: func,
   handleClearEvent: func,
   handleFilterUniqueItems: func,
   item: object,
   headerData: array,
   uniqueFilters: array,
   rowData: array,
   isScroll: bool,
   isMultiFilter: bool,
   isToolTipShow: bool,
};
export default TableHeader;
